import type { BaseErrorInterface, BaseMessageInterface, ServiceResponseInterface } from '@nts/std/interfaces';
import { BaseError, Exception, Information, Warning } from '@nts/std/messages';
import { Expose, Type } from '@nts/std/serialization';

export class ServiceResponse implements ServiceResponseInterface {

  private _opSuccedeed: boolean;

  @Expose()
  get operationSuccedeed(): boolean {
    return (this.errors?.length !== 0) ? false : this._opSuccedeed;
  }

  set operationSuccedeed(value: boolean) {
    this._opSuccedeed = value;
  }

  @Expose()
  @Type(() => Information)
  informations: BaseMessageInterface[];

  @Expose()
  @Type(() => BaseError)
  errors: BaseErrorInterface[];

  @Expose()
  @Type(() => Exception)
  exceptions: BaseMessageInterface[];

  @Expose()
  @Type(() => Warning)
  warnings: BaseMessageInterface[];

  constructor() {
    this._opSuccedeed = true;
    this.errors = new Array<BaseErrorInterface>();
    this.informations = new Array<BaseMessageInterface>();
  }

  toString(): string {
    let ret: string = null;
    if (this.errors != null) {
      ret += 'ERROR: ';
      this.errors.forEach((err) => {
        ret += err.description + '; ';
      });
    }
    if (this.informations != null) {
      ret += 'INFORMATION: ';
      this.informations.forEach((info) => {
        ret += info.description + '; ';
      });
    }
    if (ret == null) {
      return 'ServiceResponse';
    } else {
      return ret;
    }
  }

}
